import { endpoints } from "@valenzinsights/app-config";
import { backendApiClient } from "@valenzinsights/data-access";
import axios from "axios";

export const isDirectLineTokenValid = (
    botConversationId = "",
    displayWebChat: (data: string) => void,
    displayErrorMessage: () => void,
    docId?: string,
    documentName?: string,
) => {
    if (botConversationId) {
        backendApiClient()
			.get(`/directline/token?conversationId=${botConversationId}`)
			.then((res) => {
				if (res.data == "" || res.data == "Token is expired") {
					createDirectLineToken(
						displayWebChat,
						displayErrorMessage,
						docId,
						documentName,
					);
				} else {
					displayWebChat(res.data as string);
				}
			})
            .catch((error) => {
                displayErrorMessage();
            });
    } else {
        createDirectLineToken(
            displayWebChat,
            displayErrorMessage,
            docId,
            documentName,
        );
    }
};

export const createDirectLineToken = (
    displayWebChat: (data: string) => void,
    displayErrorMessage: () => void,
    docId?: string,
    documentName?: string,
) => {
    backendApiClient()
		.get("/directline/newconversation")
		.then((res) => {
			const resData = res.data as { conversationId: string };

			backendApiClient()
				.post(`/directline/token?conversationId=${resData.conversationId}`, {
					SourceFile: documentName,
				})
				.then((response) => {
					localStorage.setItem(
						`libBotConversationId_${docId}`,
						resData.conversationId,
					);
					if (response.data != "") {
						displayWebChat(response.data as string);
					} else {
						displayErrorMessage();
					}
				});
		})
        .catch((error) => {
            displayErrorMessage();
        });
};

export const copyAccessor = async (encryptedText: string) => {
    const response = await axios.post(
        `${endpoints.backendApiUrl}/utils/decompress`,
        {
            encryptedText: encryptedText,
        },
    );
    return response.data;
};
